import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { get } from 'lodash'

const GET_INTERCOM_TOKEN = gql`
  query GetIntercomToken {
    getIntercomToken {
      appId
      token
    }
  }
`

export function useIntercomMessenger(): {
  intercomToken: string
  intercomAppId: string
  isIntercomConfigured: boolean
} {
  const result = useQuery(GET_INTERCOM_TOKEN)

  const intercomToken = get(result, `data.getIntercomToken.token`)
  const intercomAppId = get(result, `data.getIntercomToken.appId`)

  // The backend returns placeholder strings (e.g. "INTERCOM_APP_ID NOT SET")
  // when the env vars aren't configured for an environment. Only treat Intercom
  // as usable when we have a real token + app id.
  const isIntercomConfigured =
    !!intercomToken && !!intercomAppId && !intercomAppId.includes('NOT SET')

  return { intercomToken, intercomAppId, isIntercomConfigured }
}
